import type { Contact } from "@repo/app-types/entities/contact";
import { CustomFieldProvider } from "@repo/app-types/entities/customField";
import type { FC } from "react";
import { UserCustomFieldsSection } from "./userCustomFieldsSection.js";

interface ContactUserCustomFieldsSectionProps {
  contact: Contact;
}

export const ContactUserCustomFieldsSection: FC<
  ContactUserCustomFieldsSectionProps
> = ({ contact }) => {
  // Filter custom fields to only include user-defined ones
  const customFields = contact.custom_fields?.filter(
    (customField) => customField.provider === CustomFieldProvider.User,
  );

  return (
    <UserCustomFieldsSection
      label="Contact custom fields"
      customFields={customFields}
    />
  );
};
